import { useEffect, useState } from 'react'
import { getPageContainer, subscribeScrollbarWidth } from '../functions'

const useScrollbarWidth = (element?: HTMLElement): number | undefined => {
	element = element || getPageContainer()

	const [scrollbarWidth, setScrollbarWidth] = useState<number | undefined>(undefined)

	useEffect(() => {
		if (!element) {
			return
		}

		const unsubscribe = subscribeScrollbarWidth(element, scrollbarWidth => setScrollbarWidth(scrollbarWidth))

		return () => unsubscribe()
	}, [element])

	return scrollbarWidth
}

export default useScrollbarWidth
